module.exports = __webpack_public_path__ + "img/113.760cf9d7.svg";